import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as actionTypes from "../../store/actions";
import "./TicketBody.css";
import copy from 'copy-to-clipboard';
import Answer from "./Answer";
import ImgTicketBody from "./ImgTicketBody";

import setToLocalStorageErrorItem from "../../shared/LocalStorageFunctions/setToLocalStorageErrorItem";
import removeFromLocalStorageErrorItem from "../../shared/LocalStorageFunctions/removeFromLocalStorageErrorItem";
import generateErrorTasksForExam from "../../shared/functions/generateErrorTasksForExam";
import achivmentsHandler from "../../main/components/Achivments/achivmentsHandler";
import { setAlert } from "../../store/actions/alert";
import achivmentsAlertHandler from "../../shared/components/Alert/achivmentsAlertHandler";

import useWindowDimensions from "../../WindowDimensions-hook/useWindowDimensions";

const TicketBody = (props) => {
  const headerRef = useRef();
  const { width } = useWindowDimensions();
  function findHolePosition(category) {
    let hole;
    if (category === "exam") {
      props.tasks.forEach((el, elIndex) => {
        if (
          !props.numbersStateArray
            .map((task) => parseInt(task.id))
            .includes(elIndex + 1)
        )
          hole = elIndex + 1;
      });
    } else {
      props.tasks.forEach((el) => {
        if (!props.numbersStateArray.map((task) => task.id).includes(el.taskId))
          hole = el.taskId;
      });
    }
    return hole;
  }

  const history = useHistory();
  const categoryTickets = props.categoryTickets;
  const currentTaskUrlId = props.paramsTaskId;

  const [isError, setIsError] = useState(null);
  const [hintButtonState, setHintButtonState] = useState(false);
  const [clickedAnswerId, setClickedAnswerId] = useState(null);
  const [pressedKey, setPressedKey] = useState(null);

  let shouldRenderNextButton;

  // Подмена ссылки в кнопке.
  let incrementedTaskId;
  let currentTaskIndex;

  const nextTaskLink = () => {
    if (props.ticketId !== undefined)
      return `/${categoryTickets}/${props.ticketId}/${props.tasks[incrementedTaskId].taskId}/`;
    else if (categoryTickets === "examAB" || categoryTickets === "examCD" || categoryTickets === "newAB" || categoryTickets === "newCD")
      /* return `/${categoryTickets}/${props.tasks[incrementedTaskId].taskId}`; */
      return `/${categoryTickets}/${incrementedTaskId + 1}/`;
    /* return `/${categoryTickets}/${props.tasks.indexOf(props.tasks[incrementedTaskId]) + 1}`;*/
  };

  const findIndexNextNumbersStateArrayEl = () => {
    if (props.categoryTickets.substr(0, 4) !== "exam" && props.categoryTickets !== "newAB" && props.categoryTickets !== "newCD") {
      nextNumbersStateArrayEl = props.numbersStateArray.findIndex(
        (el) =>
          parseInt(el.id) === parseInt(props.tasks[currentTaskIndex + i].taskId)
      );
    } else {
      nextNumbersStateArrayEl = props.numbersStateArray.findIndex(
        (el) =>
          parseInt(el.taskId) ===
          parseInt(props.tasks[currentTaskIndex + i].taskId) &&
          parseInt(el.ticketId) ===
          parseInt(props.tasks[currentTaskIndex + i].ticketId)
      );
    }
    return nextNumbersStateArrayEl;
  };

  if (props.categoryTickets.substr(0, 4) !== "exam" && props.categoryTickets !== "newAB" && props.categoryTickets !== "newCD") {
    currentTaskIndex = props.tasks.findIndex(
      (task) => parseInt(task.taskId) === parseInt(currentTaskUrlId)
    );
  } else {
    currentTaskIndex = props.currentTaskExamIndex;
  }

  let i = 1;
  let nextNumbersStateArrayEl;
  let flag = true;

  while (flag) {
    if (currentTaskIndex + i === props.tasks.length) {
      currentTaskIndex = -1;
      i = 1;
    }
    nextNumbersStateArrayEl = findIndexNextNumbersStateArrayEl();
    if (nextNumbersStateArrayEl !== -1) {
      i = i + 1;
    } else {
      incrementedTaskId = currentTaskIndex + i;
      flag = false;
    }
  }

  const hintHandler = () => {
    setHintButtonState(true);
  };

  const wrongAnswerHandler = async (clickedAnswerId, isError) => {
    //скролл к ошибке
    /*   if (isError && width <= 568) {
        window.scrollTo(
          0,
          headerRef.current.offsetTop - headerRef.current.offsetHeight
        );
      } */
    if (!isError && width <= 568) {
      window.scrollTo(0, 0);
    }
    if (isError) {
      achivmentsAlertHandler(achivmentsHandler(["badAss"]), props.setAlert);
    }

    setClickedAnswerId(clickedAnswerId);
    setIsError(isError);
    if (isError !== null && hintButtonState) {
      setHintButtonState(false);
    }
    if (isError !== null && props.categoryTickets.substr(0, 4) !== "exam" && props.categoryTickets !== "newAB" && props.categoryTickets !== "newCD") {
      // задержка перед рендером Компонента с результатом
      if (props.numbersStateArray.length === props.loadedBiletTasksLength - 1) {
        if (!isError) {
          setTimeout(() => {
            props.setNumbersStateArray(
              currentTaskUrlId,
              isError,
              clickedAnswerId
            );
          }, 600);
        }
      } else
        props.setNumbersStateArray(currentTaskUrlId, isError, clickedAnswerId);
    } else if (
      isError !== null &&
      (props.categoryTickets.substr(0, 4) === "exam" || props.categoryTickets === "newAB" || props.categoryTickets === "newCD")
    ) {
      // задержка перед рендером Компонента с результатом
      if (props.numbersStateArray.length === props.loadedBiletTasksLength - 1) {
        if (!isError) {
          setTimeout(() => {
            props.setNumbersStateArray(
              currentTaskUrlId,
              isError,
              clickedAnswerId,
              props.tasks[currentTaskUrlId - 1].ticketId,
              props.tasks[currentTaskUrlId - 1].taskId
            );
          }, 600);
        }
      } else
        props.setNumbersStateArray(
          currentTaskUrlId,
          isError,
          clickedAnswerId,
          props.tasks[currentTaskUrlId - 1].ticketId,
          props.tasks[currentTaskUrlId - 1].taskId
        );
    }

    if (
      isError &&
      (props.categoryTickets === "themeAB" ||
        props.categoryTickets === "themeCD")
    ) {
      setToLocalStorageErrorItem(
        props.realTaskId,
        props.themeTicketId,
        props.categoryTickets
      );
    }
    else if (isError && (props.categoryTickets === "newAB" ||
      props.categoryTickets === "newCD")) {
      setToLocalStorageErrorItem(
        props.realTaskId,
        props.themeTicketId,
        props.categoryTickets
      );
    }
    else if (isError &&
      (props.categoryTickets === "ticketsAB" ||
        props.categoryTickets === "ticketsCD")) {
      setToLocalStorageErrorItem(
        currentTaskUrlId,
        props.ticketId,
        props.categoryTickets
      );
    } else if (
      isError &&
      (props.categoryTickets === "examAB" || props.categoryTickets === "examCD")
    ) {
      const numbersStateArrayWithUniqTaskId = [];
      props.numbersStateArray.forEach((el) => {
        if (
          !numbersStateArrayWithUniqTaskId
            .map((newEl) => newEl.taskId)
            .includes(el.taskId)
        ) {
          numbersStateArrayWithUniqTaskId.push(el);
        }
      });

      if (
        numbersStateArrayWithUniqTaskId.filter((el) => el.isError).length < 2 &&
        props.currentTaskExamIndex < 20
      ) {
        // генерирует массив новых заданий
    
        async function generateErrorTasksForExamAsync () {
         const newGenTasks = await generateErrorTasksForExam(
            props.categoryTickets,
            currentTaskUrlId,
            props.loadedBilet.tasks[currentTaskUrlId - 1].ticketId
          );
          return newGenTasks;
        }

        const newGenTasks = await generateErrorTasksForExamAsync();

        // соединяет старые задания из стора с сгенерированными
        let newTasks = props.loadedBilet.tasks.concat(newGenTasks);
        // создаём новый билет, в котором к старому массиву тасков добавлен новый.
        let newBilet = { ...props.loadedBilet, tasks: newTasks };

        props.setLoadedBilet(newBilet);

        // добавляем дополнительные 5 минут времени
        props.setShouldAddFiveMinutes(true);
      }

      setToLocalStorageErrorItem(
        props.loadedBilet.tasks[currentTaskUrlId - 1].taskId,
        props.examTicketId,
        props.categoryTickets
      );
    } else if (
      !isError &&
      (props.categoryTickets === "errorsAB" ||
        props.categoryTickets === "errorsCD")
    ) {
      achivmentsAlertHandler(
        achivmentsHandler(["errorsResolve"]),
        props.setAlert
      );
      removeFromLocalStorageErrorItem(
        currentTaskUrlId,
        props.ticketId,
        props.categoryTickets
      );
    }
    // скипается на следующий вопрос, если ответ верен
    if (!isError) {
      if (props.numbersStateArray.length !== props.loadedBiletTasksLength - 1) {
        setTimeout(() => {
          history.push(nextTaskLink());
          props.setClickedAnswerId(null);
          setIsError(null);
        }, 560);
      }
    }
  };

  const onNextButtonClick = () => {
    props.setClickedAnswerId(null);
    window.scrollTo(0, 0);
  };

  const onFinishTestButtonClick = useCallback(() => {
    window.scrollTo(0, 0);
    props.setClickedAnswerId(null);
    if (props.categoryTickets.substr(0, 4) !== "exam") {
      props.setNumbersStateArray(currentTaskUrlId, isError, clickedAnswerId);
    } else if (props.categoryTickets.substr(0, 4) === "exam") {
      props.setNumbersStateArray(
        currentTaskUrlId,
        isError,
        clickedAnswerId,
        props.tasks[currentTaskUrlId - 1].ticketId,
        props.tasks[currentTaskUrlId - 1].taskId
      );
    }
  }, [clickedAnswerId, currentTaskUrlId, isError, props]);
  /*   console.log(props.numbersStateArray.length, "numbersStateArray.length");
  console.log(props.tasks.length - 1, "props.tasks.length - 1"); */

  if (props.numbersStateArray.length === props.tasks.length - 1) {
    props.numbersStateArray.sort(function (a, b) {
      var keyA = a.id,
        keyB = b.id;
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    let holePosition;
    if (props.categoryTickets.substr(0, 4) === "exam")
      holePosition = findHolePosition("exam");
    else holePosition = findHolePosition("other categoryTickets");
    if (parseInt(holePosition) === parseInt(props.paramsTaskId)) {
      shouldRenderNextButton = false;
    } else shouldRenderNextButton = true;
  } else {
    shouldRenderNextButton = true;
  }

  useEffect(() => {
    const nextTaskLink2 = () => {
      if (props.ticketId !== undefined)
        return `/${categoryTickets}/${props.ticketId}/${props.tasks[incrementedTaskId].taskId}/`;
      else if (categoryTickets === "examAB" || categoryTickets === "examCD" || categoryTickets === "newAB" || categoryTickets === "newCD")
        return `/${categoryTickets}/${incrementedTaskId + 1}/`;
    };

    const setPressedKeyHandler = (e) => {
      if (isError === null) {
        setPressedKey(parseInt(e.key) - 1);
      }
    };
    const onKeyDown = (e) => {
      switch (e.key) {
        case " ":
          e.preventDefault();
          if (!shouldRenderNextButton && isError) {
            onFinishTestButtonClick();
          } else {
            props.setClickedAnswerId(null);
            setIsError(null);
            window.scrollTo(0, 0);
            history.push(nextTaskLink2());
          }
          break;
        case "1":
          setPressedKeyHandler(e);
          break;
        case "2":
          setPressedKeyHandler(e);
          break;
        case "3":
          setPressedKeyHandler(e);
          break;
        case "4":
          setPressedKeyHandler(e);
          break;
        case "5":
          setPressedKeyHandler(e);
          break;

        default:
          break;
      }
    };

    document.addEventListener("keydown", onKeyDown);

    return () => {
      setPressedKey(null);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [
    history,
    categoryTickets,
    incrementedTaskId,
    props.tasks,
    props.ticketId,
    props,
    pressedKey,
    isError,
    shouldRenderNextButton,
    onFinishTestButtonClick,
  ]);

  useEffect(() => {
    if (isError !== null && hintButtonState) {
      setHintButtonState(false);
    }
    return history.listen((location) => {
      if (isError)
        setIsError(null);
      if (hintButtonState) setHintButtonState(false);
    });
  }, [
    history,
    hintButtonState,
    isError,
    props.numbersStateArray.length,
    props.tasks.length,
    shouldRenderNextButton,
    props.achivmentsReducer,
    props.setAlert,
  ]);

  const shareQuestionHandler = () => {
    const domainName = 'https://pddportal.ru';
    let shareLink;
    let normalizeCategoryTickets;

    if (
      categoryTickets.substring(
        props.categoryTickets.length,
        props.categoryTickets.length - 2
      ) === "AB"
    ) {
      normalizeCategoryTickets = "ticketsAB";
    }
    else {
      normalizeCategoryTickets = "ticketsCD";
    }

    if (categoryTickets === "themeAB") { normalizeCategoryTickets = "themeAB"; }

    if (props.categoryTickets === "examAB" || props.categoryTickets === "examCD") {
      shareLink = `${domainName}/${normalizeCategoryTickets}/${props.examTicketId}/${props.tasks[currentTaskUrlId - 1].taskId}/`;
    }
    else if (props.categoryTickets === "newAB" || props.categoryTickets === "newCD") {
      shareLink = `${domainName}/${normalizeCategoryTickets}/${props.examTicketId}/${props.tasks[currentTaskUrlId - 1].realTaskId}/`;
    }
    else {
      shareLink = `${domainName}/${normalizeCategoryTickets}/${props.ticketId}/${currentTaskUrlId}/`;
    }

    const shareLinkWithUTM = shareLink + "?utm_source=share_q";
    copy(shareLinkWithUTM);
    props.setAlert(shareLink, "share", 4500)
  }

  return (
    <div>

      <ImgTicketBody
        img={props.img}
        incrementedTaskId={incrementedTaskId}
        tasks={props.tasks}
        history={history}
      />

      <div itemScope itemType="http://schema.org/Question">
        <h2 itemProp="name" className="question" ref={headerRef}>
          {props.categoryTickets === "newAB" || props.categoryTickets === "newCD" ?
            <span>
              <span className="question-badje">{`Билет ${props.tasks[currentTaskUrlId - 1].ticketId}. Вопрос ${props.tasks[currentTaskUrlId - 1].realTaskId} ${props.tasks[currentTaskUrlId - 1].label}`}</span> {props.question}
            </span>
            : props.question}
        </h2>
        <div className="answers">
          {props.answers.map((answer, index) => (
            <Answer
              key={index}
              id={index}
              answer={answer}
              hint={props.hint}
              rightAnswer={props.rightAnswer}
              isError={isError}
              wrongAnswerHandler={wrongAnswerHandler}
              categoryTickets={categoryTickets}
              pressedKey={pressedKey}
            />
          ))}
        </div>
      </div>
      <div
        className={
          !hintButtonState
            ? "controll-buttons"
            : "controll-buttons controll-buttons-col"
        }
      >
        <div
          onClick={hintHandler}
          className={
            "hint-button " +
            (hintButtonState || isError !== null ? "display-none " : "")
          }
        >
          Подсказка
        </div>
        {hintButtonState && <div className="hint-text">{props.hint}</div>}
        {shouldRenderNextButton ? (
          <Link
            onClick={onNextButtonClick}
            to={nextTaskLink()}
            className="next-button"
          >
            Далее
          </Link>
        ) : isError ? (
          <Link
            onClick={onFinishTestButtonClick}
            to={nextTaskLink()}
            className="next-button"
          >
            Закончить тест
          </Link>
        ) : (
          ""
        )}
        <div onClick={shareQuestionHandler} title="Поделиться ссылкой на вопрос" className="next-button"> <i className="fas fa-share"></i></div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    numbersStateArray: state.ticketsReducer.numbersStateArray,
    loadedBiletTasksLength: state.ticketsReducer.loadedBilet.tasks.length,
    curPath: state.router.location.pathname,
    loadedBilet: state.ticketsReducer.loadedBilet,
    achivmentsReducer: state.achivmentsReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoadedBilet: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
    setNumbersStateArray: (
      paramsTaskId,
      wrongAnswer,
      clickedAnswerId,
      ticketId,
      taskId
    ) =>
      dispatch({
        type: actionTypes.SET_NUMBERS_STATE_ARRAY,
        arrayItem: {
          id: paramsTaskId,
          isError: wrongAnswer,
          clickedAnswer: clickedAnswerId,
          ticketId: ticketId,
          taskId: taskId,
        },
      }),
    setClickedAnswerId: (id) =>
      dispatch({
        type: actionTypes.SET_CLICKED_ANSWER_ID,
        clickedAnswerId: id,
      }),
    setShouldAddFiveMinutes: (flag) =>
      dispatch({
        type: actionTypes.SET_SHOULD_ADD_FIVE_MINUTES,
        shouldAddFiveMinutes: flag,
      }),
    setAlert: setAlert(dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketBody);
